import React from "react";
import Script from "next/script";
import { BrandService } from "@/src/BrandService";

declare global {
    interface Window {
        wsSEOfixer?: { configure: (cfg: { hostURL: string; siteID: string }) => void };
    }
}

const WRITESONIC_SITE_IDS: Record<string, string> = {
    default: "68e6c615a0f1b1cbc8734281",
    canada: "69df9e67f096ab00566bfbe9"
};

const WRITESONIC_HOST_URL = "https://seo-fixer.writesonic.com";

export const WriteSonicSEOFixer: React.FC = () => {
    const brandId = BrandService.getCurrentBrandData().id;
    const siteID = WRITESONIC_SITE_IDS[brandId];

    if (!siteID) return null;

    return (
        <Script
            id="wsAiSeoMb"
            src={`${WRITESONIC_HOST_URL}/site-audit/fixer-script/index.js`}
            strategy="afterInteractive"
            onLoad={() => {
                window.wsSEOfixer?.configure({ hostURL: WRITESONIC_HOST_URL, siteID });
            }}
        />
    );
};
